import detailApiCall from './detail';
import listApiCall from './list';

const ApiCall = {
  list: listApiCall,
  detail: detailApiCall,
};

export default ApiCall;
